
export const mediaItemSchema = {
  filename: '',
  sourceFilename: '',
  mime: '',
  source: '',
  size: 0,
  attributes: {},
  type: '',
  title: ''
}

export const workSchema = {
  _id: '',
  title: '',
  medium: '',
  mediaItems: [],
  year: null,
  description: '',
  size: '',
}

export const slideSchema = {
  ...mediaItemSchema,
  work: workSchema,
  submission: {
    _id: '',
    checked: false,
    longRead: false,
    marked: false,
    returnTo: false,
    shortlisted: false,
    hasSelectedWork: false,
    createdAt: null,
    modifiedAt: null,
  }
}


export const addressSchema = {
  street: '',
  locality: '',
  region: '',
  postcode: '',
  countryCode: 'GB'
}

export const phoneSchema = {
  type: 'mobile',
  identifier: '',
  notes: ''
}

export const questionSchema = {
  _id: '',
  key: "",
  type: "",
  text: "",
  options: [],
  weight: 0,
  show: {
    key: '',
    value: null
  },
  active: true
}

export const userSchema = {
  _id: '',
  firstName: '',
  lastName: '',
  identifier: '',
  role: '',
  active: false,
  signUp: false,
  login: null,
  createdAt: null,
  modifiedAt: null
}

export const messageSchema = {
  _id: '',
  key: '',
  subject: '',
  body: '',
  fromName: '',
  fromMail: '',
  createdAt: null,
  modifiedAt: null
}

export const fileSchema = {
  name: "",
  extension: "",
  size: "",
  ctime: "",
  mtime: ""
};
